// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-sources-preview {
  padding-top: 20px;
}
.player-sources-preview__item {
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
.player-sources-preview__item h3 {
  font-size: 14px;
  margin-bottom: 0;
}
.player-sources-preview__item:hover .player-sources-preview__title-background {
  display: block;
  z-index: 1;
}
.player-sources-preview__wrapper {
  z-index: 3;
}
.player-sources-preview__title-background {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(1, 1, 1, 0.4);
  display: none;
}
.player-sources-preview__title-background h3 {
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.player-sources-preview .vjs-big-play-button {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Drawer/SourcesPreview/SourcesPreview.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AACI;EACI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;AACZ;AAGY;EACI,cAAA;EACA,UAAA;AADhB;AAMI;EACI,UAAA;AAJR;AAOI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;AALR;AAOQ;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AALZ;AASI;EACI,aAAA;AAPR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
